import {Component, computed, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Router, RouterModule} from "@angular/router";
import {HeaderService} from "../../services/header.service";
import {CookieService} from "ngx-cookie-service";
import {UserService} from "../../services/user.service";
import {Observable} from "rxjs";
import {FormBase} from "../../shared/data-access/form-base";
import {ModalComponent} from "../../shared/components/modal/modal.component";
import {NavigationService} from "../../shared/data-access/navigation.service";
import {UserAvatarComponent} from "../../shared/components/user-avatar/user-avatar.component";
import {Userrole} from "../../shared/interfaces/user";

@Component({
  selector: "app-header-menu",
  standalone: true,
  imports: [CommonModule, RouterModule, UserAvatarComponent],
  templateUrl: "./header-menu.component.html",
  styleUrls: ["./header-menu.component.scss"],
})
export class HeaderMenuComponent implements OnInit {
  backgroundColor!: string;
  headerTitle: string = "";
  headerSubTitle: string = "";
  headerSubTitleClickable: boolean = false;
  headerIcon: string = "";
  headerIconColor: string = "";
  inputs$: Observable<FormBase<string>[]>;
  Userrole = Userrole;
  timeout = computed(() => this.userService.sessionTimeout());

  constructor(
    private readonly router: Router,
    private readonly header: HeaderService,
    private cookieService: CookieService,
    public userService: UserService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.header.backgroundColor$.subscribe((color) => {
      this.backgroundColor = color;
    });
    this.header.headerTitle$.subscribe((title) => {
      this.headerTitle = title;
    });
    this.header.headerSubTitle$.subscribe((subTitle) => {
      this.headerSubTitle = subTitle;
    });
    this.header.headerIcon$.subscribe((iconObject) => {
      this.headerIcon = iconObject.icon;
      this.headerIconColor = iconObject.color
    });
    this.header.headerSubTitleClickable$.subscribe((isClickable) => {
      this.headerSubTitleClickable = isClickable;
    });
  }

  logout() {
    this.userService.logout();
  }

  selectWorkplace() {
    if (
      this.router.url === "/dashboard" &&
      this.userService.userrole() === Userrole.Mitarbeiter
    ) {
      this.cookieService.delete("productionLine");
      this.cookieService.delete("workplace");
      this.router.navigate(["/select"]);
    }
  }
}
